import ReadableFilter from "components/CRM/ReadableFilter";
import FiltersButton from "components/SavedFilters/FiltersButton";
import useModule from "hooks/useModule";
import { SelectPicker } from "rsuite";
import _ from "underscore";
import useAvailableActions from "./useAvailableActions";
import useReferencedAction from "./useReferencedAction";
import FilterInput from "../../../../components/SavedFilters/FilterInput";

const MenuItem = (label, item) => (
  <div style={{ maxWidth: 400 }}>
    <div style={{ fontSize: 15 }} className="text-dark font-weight-500">
      Action {item.Index}: {label}
    </div>
  </div>
);

const IfElseCase = ({ action, setAction, actions }) => {
  const { availableActions } = useAvailableActions({ actions });
  const { moduleAPIName } = useReferencedAction({ action, actions });
  const { module } = useModule(moduleAPIName);

  const onReferencedActionChange = (newActionID) => {
    const foundAction = _.findWhere(availableActions, { id: newActionID });

    const payload = {
      ReferencedAction: newActionID,
      Evaluation: {},
      Name: `Evaluation of Action ${foundAction.Index} Records`,
      Description: `Evaluate records created & updated in Action ${foundAction.Index} using a query. Perform additional actions based on the outcome of the evaulation.`,
    };

    setAction((prev) => ({ ...prev, ...payload }));
  };

  const onEvaluationChange = (newQuery) => {
    setAction((prev) => ({ ...prev, Evaluation: newQuery }));
  };

  return (
    <>
      <h3 className="mt-2 mb-0">Select Workflow Action</h3>
      <small>
        Select a workflow action that you want to create a conditional for.
      </small>
      <SelectPicker
        preventOverflow
        data={availableActions}
        style={{ width: "100%" }}
        placeholder="Select Action"
        onChange={onReferencedActionChange}
        value={action?.ReferencedAction}
        labelKey={"Name"}
        valueKey={"id"}
        searchable={false}
        renderMenuItem={(label, item) =>
          MenuItem(label, item, action?.TagsAction)
        }
        renderValue={(_, item) => "Action " + item?.Index + ": " + item?.Name}
        className="mt-2"
      />
      {moduleAPIName && (
        <>
          <hr className="my-4" />
          <FilterInput
            title="Condition"
            currentModule={module}
            query={action?.Evaluation}
            setQuery={onEvaluationChange}
            onApply={null}
            onClear={null}
            saveAs={false}
            checkForFields={false}
            fallbackMessage="No Condition(s) Added."
            smallText="Click the box above to edit the Condition."
            moduleAPIName={moduleAPIName}
            showVariables={false}
          />
        </>
      )}
    </>
  );
};

export default IfElseCase;
